// Firebase Core
import { initializeApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
  inMemoryPersistence,
  GoogleAuthProvider
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// --- Firebase Config ---
const firebaseConfig = {
  apiKey: "AIzaSyBwCw0vAVhVyYQYzSVeidCUygvvszedEhA",
  authDomain: "konvenio-c3e45.firebaseapp.com",
  projectId: "konvenio-c3e45",
  storageBucket: "konvenio-c3e45.firebasestorage.app",
  messagingSenderId: "335807616535",
  appId: "1:335807616535:web:67ba3565d4879d1e0b2e52",
  measurementId: "G-L4YP40YG5D"
};

// Init Firebase
const app = initializeApp(firebaseConfig);

// Auth
const auth = getAuth(app);
const managerCreationApp = initializeApp(firebaseConfig, "managerCreation");
const managerCreationAuth = getAuth(managerCreationApp);

// Persistence
const authReady = setPersistence(auth, browserLocalPersistence)
  .then(() => {
    console.log("%cAUTH PERSISTENCE READY", "background:green;color:white;padding:4px;");
    return auth;
  })
  .catch((err) => {
    console.error("Error setting persistence:", err);
    return auth;
  });

const managerCreationAuthReady = setPersistence(managerCreationAuth, inMemoryPersistence)
  .then(() => managerCreationAuth)
  .catch(() => managerCreationAuth);

// Provider
const googleProvider = new GoogleAuthProvider();

// Firestore
const db = getFirestore(app);

// Storage  🔥 CORRECTO
const storage = getStorage(app);

// EXPORTS
export { app, auth, authReady, managerCreationAuth, managerCreationAuthReady, googleProvider, db, storage };
